import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import MainTemplateHeader from "components/MainTemplateHeader";
import { Box, useMediaQuery } from "@mui/material";
import GenericCouponView from "./GenericCouponView";
import { homeActions } from "actions";

const GenericListAndCouponView = (props) => {
  const {
    selectedProduct,
    selectedPrescription,
    backToSearchGauge,
    couponOrGenericListTitle,
    selectedAlternateList,
    productDetailId,
    zipData,
    appQuantity,
    selectedInsurance,
    storeAppData,
    selectedDosage,
    selectedQuantity,
    selectedForm,
    openSearchSettings,
    showGauge,
    couponLowestPrice = null,
    fromPrescriptions = null,
    genericDetails,
    selectedPharmacy = null,
    couponLowestPriceFromGauge,
    alternateView = false,
    setPrevSelectedCouponData = null,
  } = props;
  const [selectedGenericItem, setSelectedGenericItem] = useState(null);
  const storedZipData = JSON.parse(localStorage.getItem("storedZipData"));
  const matches500MaxWidth = useMediaQuery("(max-width:600px)");
  const styles = {
    width: "90%",
    margin: "auto",
  };
  const storedInsuranceData = JSON.parse(
    localStorage.getItem("storedInsuranceData")
  );
  // const favPharGroupId = localStorage.getItem("pharmacyGroupId");

  const updateSelectedPharmacy = (pharmacyData) => {
    storeAppData("genericInfo", {
      productDetailId:
        selectedAlternateList?.productDetailId ||
        productDetailId ||
        pharmacyData?.productDetailId ||
        couponLowestPrice?.productDetailId,
      offerId: pharmacyData?.offerId,
      insuranceId: selectedInsurance?.id || storedInsuranceData?.id,
      pbmPharmacyLocationId: pharmacyData?.pbmPharmacyLocationId,
      pbmProductDetailId: pharmacyData?.pbmProductDetailId,
      pharmacyGroupPbmId: pharmacyData?.pharmacyGroupPbmId,
      pbmId: pharmacyData?.pbmId,
      zipCode:
        storedZipData?.zipCode ||
        zipData?.zipCode ||
        pharmacyData?.zipCode ||
        couponLowestPrice?.zipCode,
      quantity: alternateView ? 0 : appQuantity,
    });
    setSelectedGenericItem(pharmacyData);
  };

  useEffect(() => {
    if (
      selectedPharmacy &&
      couponLowestPriceFromGauge &&
      Object.keys(couponLowestPriceFromGauge).length
    ) {
      updateSelectedPharmacy({
        ...couponLowestPriceFromGauge,
        ...selectedPharmacy,
      });
    }
    return () => {
      console.log("setSelectedGenericItem", selectedGenericItem);
      setSelectedGenericItem(null);
    };
  }, [couponLowestPriceFromGauge, selectedPharmacy]);

  useEffect(() => {
    if (
      fromPrescriptions &&
      couponLowestPrice &&
      Object.keys(couponLowestPrice).length
    ) {
      updateSelectedPharmacy(couponLowestPrice);
    }
  }, [fromPrescriptions, couponLowestPrice]);

  const handleViewRendering = () => {
    return (
      <Box>
        <MainTemplateHeader
          title={
            selectedAlternateList?.name ||
            selectedProduct?.productName ||
            selectedPrescription?.productName
          }
          noBack={true}
          backTitle={matches500MaxWidth ? false : true}
          showSearch={true}
          selectedDosage={
            fromPrescriptions ? genericDetails?.strength : selectedDosage
          }
          selectedQuantity={
            fromPrescriptions
              ? genericDetails?.quantity
              : selectedQuantity.quantity || ""
          }
          selectedForm={fromPrescriptions ? genericDetails?.form : selectedForm}
          openSearchSettings={
            !fromPrescriptions &&
            openSearchSettings &&
            !selectedAlternateList?.productDetailId
              ? openSearchSettings
              : null
          }
          handleBackClick={() => {
            backToSearchGauge();
          }}
        />

        <Box>
          <GenericCouponView
            setPrevSelectedCouponData={setPrevSelectedCouponData}
            showGauge={showGauge}
            additionalStyles={styles}
            selectedGenericList={couponOrGenericListTitle}
            selectedGenericItem={selectedGenericItem}
            setSelectedGenericItem={setSelectedGenericItem}
            updateSelectedPharmacy={updateSelectedPharmacy}
            fromPrescriptions={fromPrescriptions}
            couponData={couponLowestPriceFromGauge}
          />
        </Box>
      </Box>
    );
  };

  return <>{handleViewRendering()}</>;
};

const mapStateToProps = (state) => {
  return {
    selectedProduct: state.home.selectedProduct,
    selectedAlternateList: state.globalStoreInfo.selectedAlternateList,
    productDetailId: state.productDetails.productDetailId,
    zipData: state.zipData.data,
    appQuantity: state.productDetails.appQuantity,
    selectedDosage: state.productDetails.selectedDosage,
    selectedQuantity: state.productDetails.selectedQuantity,
    selectedForm: state.productDetails.selectedForm,
    selectedInsurance: state.insuranceList.selectedInsurance,
    authData: state.authentication.authData || {},
    genericDetails: state.genericDetails.data,
    couponLowestPriceFromGauge: state.couponPrice.lowestPrice,
  };
};

const mapDispatchToProps = {
  storeAppData: (type, value) => homeActions.storeAppData(type, value),
  resetData: (value) => homeActions.resetData(value),
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericListAndCouponView);
